import { CARD_TYPE } from 'modules/expenses/lib/types'

export const getCardTypeColor = (cardType: CARD_TYPE) => {
  if (cardType === 'virtual' || cardType === 'single_use') {
    return 'viridian800'
  }
  if (cardType == 'physical') {
    return 'radicalRed800'
  }
}
